<template>
  <div class="table-wrapper">
    <table>
      <caption class="visually-hidden">
        {{
          $t('CAMPAIGNS_REPORT.HEADER')
        }}
      </caption>
      <thead>
        <tr>
          <th>{{ $t('CAMPAIGNS_REPORT.TABLE.CREATED_AT') }}</th>
          <th>{{ $t('CAMPAIGNS_REPORT.TABLE.CONTACT') }}</th>
          <th>{{ $t('CAMPAIGNS_REPORT.TABLE.PHONE') }}</th>
          <th>{{ $t('CAMPAIGNS_REPORT.TABLE.STATUS') }}</th>
          <th>{{ $t('CAMPAIGNS_REPORT.TABLE.INTERACTED') }}</th>
          <th>{{ $t('CAMPAIGNS_REPORT.TABLE.ERROR') }}</th>
          <th>{{ $t('CAMPAIGNS_REPORT.TABLE.LINK_TO_CONVERSATION') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in paginatedData"
          :key="index"
          :class="{ 'striped-row': index % 2 !== 0 }"
        >
          <td>{{ formatDate(item.created_at) }}</td>
          <td>
            <span :title="item.contact_name">
              {{ truncate(item.contact_name) }}
            </span>
          </td>
          <td>
            {{ item.phone_number || '-' }}
          </td>
          <td>
            <span :title="item.status_message">
              {{ item.status_message }}
            </span>
          </td>
          <td>
            {{ item.interacted }}
          </td>
          <td>
            <span :title="item.message_error">
              {{ truncate(item.message_error) }}
            </span>
          </td>
          <td>
            <a
              :href="item.link_conversation"
              target="_blank"
              rel="noopener noreferrer"
              :title="item.link_conversation"
            >
              {{ truncate(item.link_conversation) }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        {{ $t('CAMPAIGNS_REPORT.PAGINATION.PREVIOUS') }}
      </button>
      <span>
        {{ $t('CAMPAIGNS_REPORT.PAGINATION.PAGE') }} {{ currentPage }}
        {{ $t('CAMPAIGNS_REPORT.COMMON.OF') }} {{ totalPages }}
      </span>
      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        {{ $t('CAMPAIGNS_REPORT.PAGINATION.NEXT') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignsTable',
  props: {
    campaignsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
    };
  },
  computed: {
    sortedData() {
      return [...this.campaignsData].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.sortedData.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.campaignsData.length / this.perPage);
    },
  },
  methods: {
    formatDate(dateString) {
      return new Date(dateString).toLocaleString('pt-BR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    truncate(text, maxLength = 30) {
      if (!text || typeof text !== 'string') return '-';
      return text.length > maxLength
        ? text.slice(0, maxLength - 3) + '...'
        : text;
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

thead {
  background-color: #2563eb;
  color: white;
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  word-break: break-word;
}

.striped-row {
  background-color: #f9f9f9;
}

a {
  color: #2563eb;
  text-decoration: underline;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

td span {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
</style>
